const selectOption = [
    {
        tag: "ENG",
    },
    {
        tag: "DE"
    }
]

export default selectOption;